import { render, staticRenderFns } from "./MyTransaction.vue?vue&type=template&id=b84059c0"
import script from "./MyTransaction.vue?vue&type=script&lang=js"
export * from "./MyTransaction.vue?vue&type=script&lang=js"
import style0 from "./MyTransaction.vue?vue&type=style&index=0&id=b84059c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports